import React, { useRef, useState } from 'react';
import * as S from './BusinessPageCustom.styles';
import { QuickStartSection } from './QuickStartSection/QuickStartSection';
import { BusinessPageCards } from './BusinessCards';
import { BusinessPageForm } from './BusinessForm/BusinessPageForm';
import { BusinessResultModal } from './BusinessResultModal';
import { BusinessTariffs } from './BusinessTariffs/BusinessTariffs';
import { BusinessExamples } from './BusinessExamples/BusinessExamples';
import { BusinessCreateShopSection } from './BusinessCreateShopSection/BusinessCreateShopSection';
import { BusinessPageSeo } from './BusinessPageSeo/BusinessPageSeo';
import { PackagesListData } from '@/api/types/business.types';
import { useLiteWebView } from '@/hooks/useDefaultLiteWebView';

interface BusinessPageCustomProps {
  packagesListData?: PackagesListData | null;
}

export const BusinessPageCustom: React.FC<BusinessPageCustomProps> = ({
  packagesListData,
}) => {
  const formEl = useRef<HTMLDivElement>(null);
  const isLite = useLiteWebView();

  const [showResultModal, setShowResultModal] = useState(false);

  const executeScroll = () => {
    if (formEl.current) {
      formEl.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const onClose = () => {
    setShowResultModal(false);
    window.location.reload();
  };

  return (
    <S.BusinessPageCustom>
      <BusinessPageSeo />
      <QuickStartSection onScrollToForm={executeScroll} />

      <BusinessPageCards isLite={isLite} />

      <BusinessTariffs packagesListData={packagesListData} />

      <BusinessExamples />

      <S.BusinessPageFormsContainer ref={formEl}>
        <BusinessPageForm
          formElRef={formEl}
          setShowResultModal={setShowResultModal}
        />
        <BusinessCreateShopSection />
      </S.BusinessPageFormsContainer>
      <BusinessResultModal
        showResultModal={showResultModal}
        onClose={onClose}
      />
    </S.BusinessPageCustom>
  );
};

BusinessPageCustom.displayName = 'BusinessPageCustom';
